import { Metric } from "@webapp/okrs/metrics/models/metric.models";
import { IMetricFieldsChoice, IMetricPrediction } from "../../insights/services/auto-fields.service";
import { IUnitFormatting } from "../../shared/models";

export const generateMetricPredictionAnalytics = (metric: Metric, prediction: IMetricPrediction): IMetricFieldsChoice => {
  const checkFormat = (iterateOver: "keys" | "values", format: IUnitFormatting, callback: (v: string | number) => string | number) => {
    return format ? Object[iterateOver](format).find(callback) : null;
  };

  return {
    metricId: metric.id,
    predId: prediction.predId,
    title: metric.name,
    operatorSelected: metric.targetOperator,
    operatorPredicted: prediction.targetOperator,
    targetSelected: metric.target,
    targetPredicted: prediction.target || null,
    unitSelected: checkFormat("values", metric.format, (v) => v),
    unitPredicted: checkFormat("values", prediction.format, (v) => v),
    unitTypeSelected: checkFormat("keys", prediction.format, (key) => metric.format[key]),
    unitTypePredicted: checkFormat("keys", metric.format, (key) => metric.format[key]),
    operatorModelVersion: prediction.operatorModelVersion,
    targetUnitModelVersion: prediction.targetUnitModelVersion,
    initialValuePredicted: prediction.initialValue,
    initialValueSelected: metric.initialValue,
    metadata: prediction.metadata,
  };
};
